import React from 'react';
import PropTypes from 'prop-types';

import { filterAttributes } from 'utils';

const Icon = ({
    className,
    icon,
    ...props
}) => (
    <svg
        className={className}
        focusable="false"
        {...filterAttributes(props, /^data-/)}
    ><use xlinkHref={`#icon-${icon}`} /></svg>
);

Icon.propTypes = {
    className: PropTypes.string,
    icon: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.jsx